import {
	createState,
} from './simpleDataList';

import {
	loadSitemapsRangeViaApi,
} from '~/model/sitemaps';



export const {
	loadData,
	reducer,
	selector,
} = createState(
	'orphanedSitemaps',
	(websiteId) => loadSitemapsRangeViaApi(websiteId, {
		'fields': 'url',
		'filter[is_orphaned]': true,
		'offset': 0,
		'limit': 1000,
	}),
	30,
);
